import { axios } from '@/utils/http'
import { Exam, BaseExam } from '@/models/exam'
import { TableResponse, Params } from '@/components/table'
import { paramsApdapter } from '@/utils/apdapter'

export async function get(id: string): Promise<Exam>
export async function get(params?: Params): Promise<TableResponse<Exam>>
export async function get(params?: string | Params) {
  const handle =
    typeof params === 'string'
      ? axios.get(`exam/${params}`)
      : axios.get(`exam`, { params: paramsApdapter(params) })
  const { data } = await handle
  return data
}

export async function post(exam: BaseExam) {
  const { data } = await axios.post(`exam`, exam)
  return data as Exam
}
